export const BOARD_MEETING_DATE_STATUSES = ['Deleted', 'Active'];
